// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable default-case */
import React from 'react';
import PropTypes from 'prop-types';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from './bootstrap/Modal';
import { priceFormat, priceFormatNoCents } from '../helpers/helpers';

const FinancingMonthlyEstimateModal = ({
	financingEstimateModalOpen,
	setFinancingEstimateModalOpen,
	financingEstimateData,
}) => {
	// const { oemProfileProps } = useContext(OemProfileContext);
	const { monthlyPayment, term, apr, downPayment, disclaimerText } = financingEstimateData;
	return (
		<Modal
			isOpen={financingEstimateModalOpen} // Example: state
			setIsOpen={setFinancingEstimateModalOpen} // Example: setState
			isStaticBackdrop={false}
			isScrollable
			isCentered
			size='lg' // 'sm' || 'lg' || 'xl'
			fullScreen='sm' // true || 'sm' || 'md' || 'lg' || 'xl' || 'xxl'
			isAnimation={false}>
			<ModalHeader
				className='d-flex justify-content-between'
				setIsOpen={setFinancingEstimateModalOpen} // Example: setState
			>
				<ModalTitle
					id='test'
					className='h3 d-flex justify-content-end'
					style={{ textAlign: 'left' }}>
					Est. {priceFormatNoCents(monthlyPayment)}/mo*
				</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div className='col-12'>
					<p className='text-muted pb-3'>
						Here's a breakdown of your estimated monthly payment:
					</p>
					<br />
					<hr />
					<div className='col-12 d-flex justify-content-between'>
						<div className='hor-stack'>
							<div className='block-top'>{priceFormat(downPayment)}</div>
							<div className='block-bottom'>Down payment</div>
						</div>
						<div className='hor-stack'>
							<div className='block-top'>{Math.round(apr * 100 * 100) / 100}%</div>
							<div className='block-bottom'>APR</div>
						</div>
						<div className='hor-stack'>
							<div className='block-top'>{term?.toString()}</div>
							<div className='block-bottom'>Months</div>
						</div>
					</div>
					<hr />
				</div>
				<br />
			</ModalBody>
			<ModalFooter className='d-flex justify-content-start'>
				<br />
				<p className='text-muted table-section-subtitle'>*{disclaimerText}</p>
			</ModalFooter>
		</Modal>
	);
};

FinancingMonthlyEstimateModal.propTypes = {
	financingEstimateData: PropTypes.shape({
		monthlyPayment: PropTypes.number,
		description: PropTypes.string,
		term: PropTypes.number,
		apr: PropTypes.number,
		downPayment: PropTypes.number,
		disclaimerText: PropTypes.string,
	}).isRequired,
	financingEstimateModalOpen: PropTypes.bool.isRequired,
	setFinancingEstimateModalOpen: PropTypes.func.isRequired,
};

export default FinancingMonthlyEstimateModal;
